import React,{Component} from "react";
import { Link,Redirect } from "react-router-dom";
import {getData} from '../services/index';



import ReactToPrint from 'react-to-print';
import QRCode from "react-qr-code";

export class ComponentToDownload extends Component {
	state = { 
		link: '' ,
		id: '' ,
		shipping_details: [],
		};
	
	
	componentWillReceiveProps(nextProps) {
		//alert(nextProps.title);
		setTimeout(() => {
			this.setState({	modal_print: false,});
		}, 100);
		
		var storedArray = JSON.parse(localStorage.getItem("schoolData"));
		var school_id = storedArray['data'][0]['school_id'];
		var app = {school_id:school_id,user_id:nextProps.title}
		getData('erp/qr_details',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
					this.setState({
						shipping_details: result['data'],
						modal_print: true
					});
					document.getElementById('text_alert').innerHTML = '';
				}else{
					this.setState({
						shipping_details: [],
						modal_print: true
					});
					document.getElementById('text_alert').innerHTML = '';
				}
			}
		});
	}
	
	componentWillMount() {
		
	}
	
	render()
	{
		return (
			<div>

			{this.state.shipping_details.map((list) => (	
				<section id="data-list-view" class="print-this" >
					<body>
					  <div class="panel-body tbold" id="page-wrap">
						
							{list.student.map((data)=>(
							<table id="invoice" class="m-t-20">
								<tbody>
									<tr>
										<td>
											<div class="row">
												<div class="col m8 s8 col-md-8 text-left">
													<p><b>Child Name: </b>{data.student_name}</p>
													<p><b>Program Name: </b>  {data.program_name}</p>
													<p><b>Parent Name: </b>{data.parent_name}</p>
													<p><b>Mobile No.: </b> {data.parent_number}</p>		
												</div>	
												<div class="col m4 s4 col-md-4">
													<QRCode value={data.qrcode} size="100" />	
												</div>	
											</div>	
										</td>
									</tr>
									
								</tbody>
							</table>
							
							))}
							
							
						</div>	
					</body>
				</section>
				
				
				
			))}	
			
			<div class="no-found">
					<div class="col-sm-12" >
						<h5 class="text-center" id="text_alert">Please Wait while Loading !!! </h5>
					</div>
			</div>
				
			</div>
		)
	}

}